module.exports = __webpack_public_path__ + "media/app/apple-badge-fr-19e52f09.svg";